import React, { Fragment } from 'react';
import Header from '../../components/Header/Header';
import Hero from '../../components/Hero/Hero';
import TokenOffer from '../../components/TokenOffer/TokenOffer';
import ChooseSection from '../../components/chooseSection/ChooseSection';
import AboutSection from '../../components/AboutSection/AboutSection';
import ProcessSection from '../../components/ProcessSection/ProcessSection';
import ElimentsSection from '../../components/ElimentsSection/ElimentsSection';
import RoadmapSection from '../../components/roadmapSection/RoadmapSection';
import TokenomicsSection from '../../components/TokenomicsSection/TokenomicsSection';
import FAQSection from '../../components/faqSection/FaqSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const HomePage = () => {
    return (
        <Fragment>
            <div className='index_memecoin page_wrapper'>
                <Header />
                <main className="page_content">
                    <Hero />
                    <TokenOffer />
                    <ChooseSection />
                    <AboutSection />
                    <ProcessSection />
                    <ElimentsSection />
                    <RoadmapSection />
                    <TokenomicsSection />
                    <FAQSection />
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default HomePage;